// schedulesApi.ts
import api from './api';
import { DeviceSchedule, CreateScheduleRequest, UpdateScheduleRequest } from '../types/schedules';

export const schedulesApi = {
    getAllSchedules: async (): Promise<DeviceSchedule[]> => {
        const response = await api.get('/deviceschedules');
        return response.data;
    },

    getSchedule: async (id: number): Promise<DeviceSchedule> => {
        const response = await api.get(`/deviceschedules/${id}`);
        return response.data;
    },

    createSchedule: async (schedule: CreateScheduleRequest): Promise<DeviceSchedule> => {
        const response = await api.post('/deviceschedules', schedule);
        return response.data;
    },

    updateSchedule: async (id: number, schedule: UpdateScheduleRequest): Promise<void> => {
        await api.put(`/deviceschedules/${id}`, schedule);
    },

    deleteSchedule: async (id: number): Promise<void> => {
        await api.delete(`/deviceschedules/${id}`);
    },

    getSchedulesByDevice: async (deviceId: number): Promise<DeviceSchedule[]> => {
        const response = await api.get(`/deviceschedules/device/${deviceId}`);
        return response.data;
    },

    getSchedulesByPlaylist: async (playlistId: number): Promise<DeviceSchedule[]> => {
        const response = await api.get(`/deviceschedules/playlist/${playlistId}`);
        return response.data;
    },

    getActiveSchedules: async (): Promise<DeviceSchedule[]> => {
        const response = await api.get('/deviceschedules/active');
        return response.data;
    }
};